<section class="modal-container" class="{{data?.customClass}}">
    <div class="modal-header" [class.header-bg]="data?.headerBg" mat-dialog-title>
        <h2 class="modal-title">{{ data.title | translate }}</h2>
        <button class="modal-close-icon" (click)="onClose()"  type="button">
            <span class="material-symbols-outlined close-dialog-btn flex-center"> close </span>
        </button>
    </div>
    <mat-dialog-content>
        <div class="modal-content">
            <p *ngIf="data.message">{{ data.message | translate }}</p>
            <ng-container [ngTemplateOutlet]="data['content']"> </ng-container>
            <ng-container *ngComponentOutlet="data['component']; inputs: data['inputs']"> </ng-container>
        </div>
    </mat-dialog-content>
</section>
